import React, { ReactElement, forwardRef } from "react";
import { AppBar as AppBarTop, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import {
  CustomerSelector,
  LanguageSelector,
  SubsidiarySelector,
  TenantSelector,
  Profile,
  Notification,
  FeedbackTopButton,
} from "@/features";
import MenuIcon from "@mui/icons-material/Menu";

interface AppBarProps {
  drawerWidth: number;
  toggleDrawer: () => void;
}

export const AppBar = forwardRef<HTMLElement, AppBarProps>(
  ({ drawerWidth, toggleDrawer }, ref): ReactElement => {
    return (
      <>
        <AppBarTop
          ref={ref}
          position="fixed"
          color="inherit"
          sx={{
            width: {
              sm: `calc(100% - ${drawerWidth}px)`,
            },
            boxShadow: "none",
            borderBottom: "1px solid #E4E4E7",
          }}
        >
          <Toolbar
            sx={{
              paddingLeft: 0,
              paddingRight: 0,
              "@media (min-width: 600px)": {
                paddingLeft: 0,
                paddingRight: 0,
              },
            }}
          >
            <IconButton
              color="secondary"
              edge="start"
              sx={{
                display: {
                  xs: "flex",
                  sm: "none",
                },
                justifyContent: "center",
              }}
              onClick={toggleDrawer}
            >
              <MenuIcon />
            </IconButton>

            <Box
              sx={{
                flexGrow: 1,
              }}
            />
            <TenantSelector
              sx={{
                maxWidth: "20%",
              }}
            />
            <CustomerSelector
              sx={{
                maxWidth: "20%",
              }}
            />
            <SubsidiarySelector
              sx={{
                maxWidth: "20%",
              }}
            />
            <Notification />
            <FeedbackTopButton />
            <LanguageSelector />
            <Profile />
          </Toolbar>
        </AppBarTop>
      </>
    );
  },
);

AppBar.displayName = "AppBar";
